/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { DataprocessGroup } from '../model/models';
import { DataprocessLog } from '../model/models';
import { DataprocessProcess } from '../model/models';
import { DataprocessStep } from '../model/models';
import { DataprocessSteptype } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface DataprocessServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * POST a log for executed dataprocess steps
     * A log entry is created for a executed data process step by a user
     * @param dataprocessLog DataprocessLog object to be created in the database
     */
    createDataprocessLog(dataprocessLog: DataprocessLog, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * GET a list of data process groups
     * Returns a list with all data process groups for data managing workflows
     */
    findAllDataprocessGroups(extraHttpRequestParams?: any): Observable<Array<DataprocessGroup>>;

    /**
     * GET a list of dataprocess processes
     * Returns a list with all dataprocess processes of a selected dataprocess group
     * @param dataprocessGroupId ID of the dataprocessGroup for which the dataprocess processes should be retrieved
     */
    findAllDataprocessProcessesByDataprocessGroup(dataprocessGroupId: number, extraHttpRequestParams?: any): Observable<Array<DataprocessProcess>>;

    /**
     * GET a list of dataprocessSteps
     * Returns a list with all dataprocess steps of a selected dataprocess process
     * @param dataprocessProcessId ID of the dataprocessProcess for which the dataprocess steps should be retrieved
     */
    findAllDataprocessStepsByDataprocessProcessId(dataprocessProcessId: number, extraHttpRequestParams?: any): Observable<Array<DataprocessStep>>;

    /**
     * GET a dataprocess steptype
     * Returns the dataprocess steptype of a selected dataprocess step
     * @param id ID of the dataprocessSteptype for which the steptype should be retrieved
     */
    findDataprocessSteptypeById(id: number, extraHttpRequestParams?: any): Observable<DataprocessSteptype>;

}
